import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'popper.js'
import 'bootstrap'
import './assets/css/app.scss'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css';

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
